export default __webpack_public_path__ + "0924b441b96a5cadee81bcbb7809f2f3.svg";